export default {"src":"/_next/static/media/discord.b3f4c274.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};